import ReactApexChart from "react-apexcharts";
import { GenderGraphDataType } from "../utils";
import { ApexOptions } from "apexcharts";

type PropsType = {
  graphData: GenderGraphDataType;
};

const GenderDistributionGraph = ({ graphData }: PropsType) => {
  const config: ApexOptions = {
    series: graphData.values,
    labels: graphData.keys,
    legend: {
      show: true,
      position: "bottom",
      markers: {
        fillColors: ["#23BFCE", "#90A3D1"],
      },
      labels: {
        colors: ["#373d3f"],
      },
    },
    chart: {
      type: "donut",
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: "bold",
        colors: ["#373d3f"],
      },
      dropShadow: {
        enabled: false,
      },
    },
    tooltip: {
      enabled: false,
    },
    fill: {
      colors: ["#23BFCE", "#90A3D1"],
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
        },
      },
    },
    stroke: {
      width: 1,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              label: "",
              fontSize: "32px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              color: "#373d3f",
              formatter: function () {
                return "";
              },
            },
          },
        },
      },
    },
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={config}
          series={config.series as ApexOptions["series"]}
          type="donut"
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default GenderDistributionGraph;
